export default (context, inject) => {
  inject('tutorial', {
    totalSteps: 3,

    step1: {
      id: 'd-tutorial-1',
      title: 'tutorial.step1.title',
      currentStep: 1,
      content: 'tutorial.step1.content',
      placement: 'right',
      nextTarget: 'dummy',
      nextButtonText: 'tutorial.step1.next'
    },
    step2: {
      id: 'd-tutorial-2',
      title: 'tutorial.step2.title',
      currentStep: 2,
      content: 'tutorial.step2.content',
      nextTarget: 'd-tutorial-3',
      prevTarget: 'd-tutorial-1',
      placement: 'left',
      nextButtonText: 'tutorial.step2.next'
    },
    step3: {
      id: 'd-tutorial-3',
      currentStep: 3,
      title: 'tutorial.step3.title',
      content: 'tutorial.step3.content',
      prevTarget: 'd-tutorial-2',
      placement: 'bottom'
    }
  })
}
